<template>
<div>
	<div class="pt-3 pb-3" style="min-height:420px;" id="meditation_log">
		<div class="">
			<div class="col-12">
				<b-form-datepicker 
					v-model="meditation.date" 
					class="m-1"
					:state="meditation.date_status"
					:min="meditation_min_date" 
					:max="meditation_max_date"
					@input="meditationDateChange"
					label-no-date-selected="Select Date"
					required
				></b-form-datepicker>
			</div>
			<div class="col-12">
				<b-form-timepicker 
					v-model="meditation.start.time" 
					locale="en" 
					:state="meditation.start.status"
					class="m-1"
					required
					@input="meditationTimeChange(meditation.start)"
					label-close-button="Set"
					label-no-time-selected="Start Time"
				>
				</b-form-timepicker>
			</div>
			<div class="col-12">
				<b-form-timepicker 
					v-model="meditation.end.time" 
					locale="en" 
					:state="meditation.end.status"
					class="m-1"
					required
					@input="meditationTimeChange(meditation.end)"
					label-close-button="Set"
					label-no-time-selected="End Time"
				>
				</b-form-timepicker>
			</div>	
				
			<div class="col-12 text-right">
				<b-button 
					:variant="meditation.button_class" 
					class="btn-block m-1"
					:disabled="meditation.disabled"
					@click="meditationSubmit"
				><i :class="meditation.button_icon"></i> <span v-text="meditation.message"></span></b-button>
			</div>
		</div>
		
		<div v-if="loading === true" class="gold text-center my-2 p-2">
			<b-spinner class="align-middle"></b-spinner>
		</div>
		<div v-if="meditation_data.length > 0 && loading === false" class="mt-3 pt-2 border-top">
			
			<div class="row small">
				<b class="col-12">Meditation History</b>
			</div>
			
			<div v-for="row in meditation_data" :key="'mdlog_' + row.id" class="row small text-left">
				<div class="col-7 pt-2 pl-4" v-text="row.date"></div>
				<div class="col-3 pt-2" v-text="row.mins + '(min)'"></div>
				<div class="col-2">
					<span 
						class="btn btn-sm btn-link text-danger text-left"
						@click="meditationRemove(row)"
					>
						<i class="far fa-trash-alt"></i>
					</span>
				</div>
			</div>
			
		</div>

	</div>

</div>
</template>

<script>
import axios from "axios";
	
export default {
	name: 'MeditationManualLog',
	props: {
		embeddata: Object,
		classW: String,
		show_title: {
			type: String,
			default: '1',
		}
	},
	data() {
		const now = new Date();
		
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const minDate = new Date(today);
		minDate.setMonth(minDate.getMonth() - 2);
		minDate.setDate(15);
		const maxDate = new Date(today);
		
		return {
			meditation: {
				button_class: 'outline-secondary',
				button_icon: 'fas fa-hand-point-up',
				date: '',
				date_status: false,
				disabled: true,
				message: 'Enter Date/Time',
				start:
				{
					time: '',
					status: false,
				},
				end:
				{
					time: '',
					status: false,
				},
			},
			meditation_data: [],
			meditation_min_date: minDate,
			meditation_max_date: maxDate,
			oura_token: null,
			loading: false,
		}
	},
	computed: {
	},
	methods: {
		meditationDateChange(){
			if(this.meditation.date === ''){
				this.meditation.date_status = false;
			} else {
				this.meditation.date_status = true;
			}
			this.meditationValid();
		},
		meditationDateGet(){
			var _this = this;
			_this.loading = true;
			_this.meditation_data = [];
			
			let params = new URLSearchParams();
			params.append('token', 	_this.$store.state.session_id);
			params.append('limit', 	7);
			//console.log(_this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + "meditation_manual_get",
				params: params,

			}).then(function (response) {
				if(response.data != null){
					if(response.data.items != null){
					_this.meditation_data = Object.values(response.data.items);
					}
					
				}	
				_this.loading = false;	
			}).catch(function (error) {
				console.log(error);
			});	
		},
		
		meditationRemove(item){
			var _this = this;
			_this.loading = true;
			_this.meditation_data = [];
			
			let params = new URLSearchParams();
			params.append('token', 	_this.$store.state.session_id);
			params.append('id', 	item.delete);
			axios({
				url: _this.$store.state.api_url + "meditation_manual_delete",
				params: params,

			}).then(function (response) {
				console.log(response.data);
				/*if(response.data.items){
					_this.meditation_data = Object.values(response.data.items);
				}*/
				
				_this.meditationDateGet();
				
			}).catch(function (error) {
				console.log(error);
			});
			
		},
		
		meditationSubmit(){
			var _this = this;
			
			_this.meditation.button_icon = 'fas fa-spinner fa-spin';
			_this.meditation.message = 'Processing';
			
			let params = new URLSearchParams();
			params.append('token', 	_this.$store.state.session_id);
			params.append('date', 	_this.meditation.date);
			params.append('start', 	_this.meditation.start.time);
			params.append('end', 	_this.meditation.end.time);
			
			var now = new Date();
			var TZ_offset = now.getTimezoneOffset();
			params.append('timezone_offset', 	TZ_offset);
			
			/*console.log(section +":"+ type +":"+ duration);*/

			axios({
				url: _this.$store.state.api_url + "meditationAdd",
				params: params,

			}).then(function (response) {
				
				if(response.data.status == 1){
					
					/* reset */
					_this.meditation = {
						button_class: 'outline-secondary',
						button_icon: 'fas fa-hand-point-up',
						date: '',
						date_status: false,
						disabled: true,
						message: 'Enter Date/Time',
						start:
						{
							time: '',
							status: false,
						},
						end:
						{
							time: '',
							status: false,
						},
					}
				}
				else {
					_this.meditation.button_class = 'outline-danger';
					_this.meditation.button_icon = 'fas fa-times';
					_this.meditation.message = 'Error';
				}
				
				_this.meditationDateGet();
				
				
			}).catch(function (error) {
				console.log(error);
			});	
			
		},
		
		meditationTimeChange(id){
			if(id.time === ''){
				id.status = false;
			} else {
				id.status = true;
			}
			this.meditationValid();
		},
		meditationValid(){
			var M = this.meditation;
			const startTime = new Date(`2001-01-01T${M.start.time}Z`);
			const endTime = new Date(`2001-01-01T${M.end.time}Z`);

			console.log(endTime > startTime)
			if(M.date_status === true && M.start.status === true && M.end.status === true && endTime > startTime){
				this.meditation.disabled = false;
				this.meditation.button_class = 'success';
				this.meditation.button_icon = 'fas fa-hand-point-right';
				this.meditation.message = 'Save';
			}
			else
			{
				this.meditation.disabled = true;
				this.meditation.button_class = 'outline-secondary';
				this.meditation.button_icon = 'fas fa-hand-point-left';
				this.meditation.message = 'Enter Date/Time';
			}	
		},
		getDataStreams() {
			let _this = this;
			_this.loading = true;
			let params = new URLSearchParams();
			params.append('token', _this.$store.state.session_id);
			axios({
				url: _this.$store.state.api_url + 'dataStreamsGet',
				params: params,
			})
				.then(function (response) {
					if (response.data.status == 1) {
						if (response.data.streams.ouraring.value !== '') {
							_this.oura_token = response.data.streams.ouraring.value;
							_this.getOuraMeditation();
						}
						else {
							_this.meditationDateGet();
						} 
					}
					
				})
				.catch(function () {});
		},
		getOuraMeditation() {
			let _this = this;
			let params = new URLSearchParams();
			params.append('accessToken', _this.oura_token);
			params.append('token', _this.$store.state.session_id);
				axios({
				method: "post",
				url: _this.$store.state.api_url + "oura_meditation_fetch",
				params: params,
				})
				.then(function(response) {
					_this.meditationDateGet();
				})
				.catch(function() {});
		},
	},
	mounted() {
		this.getDataStreams();
	},
	watch: {
		
	},
	
}  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.playerD {
	width: 100%;
	height: 280px;
	text-align: left;
}
@media only screen and (max-width: 600px) {
	.playerD {
		width: 100%;
		height: 175px;
	}
}
</style>
